import axios from '../../axios'

// 新增专业信息
export const addProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/prof',
        method: 'POST',
        data
    })
}

// 获取专业信息详情
export const getProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof/info',
        method: 'GET',
        data
    })
}

// 修改专业信息
export const editProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof',
        method: 'PUT',
        data
    })
}

// 删除专业信息
export const deleteProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof',
        method: 'DELETE',
        data
    })
}

// 搜索专业信息列表
export const searchProfList = (data) => {
    return axios({
        url: '/api/data/wish/prof',
        method: 'GET',
        data
    })
}

// 导入功能
export const importProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof/import',
        method: 'POST',
        data
    })
}

// 导出功能
export const exportProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof/export',
        method: 'POST',
        data
    })
}

// 批量更新功能
export const updataProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除功能
export const queryDelProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/profinfo.js